import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * A utility function for conditionally joining classNames together
 * Uses clsx for conditional logic and tailwind-merge to handle Tailwind class conflicts
 */
export default function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
